export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.pasarpolis.mitra'
export const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/pasarpolis-mitra/id1509962969'
export const WHATS_APP_URL = 'https://api.whatsapp.com/send'
export const REFER_URL = 'https://mitra-app.pasarpolis.com/?amv=1&ibi=com.pasarpolis.mitra&isi=1509962969&imv=1.0.0&apn=com.pasarpolis.mitra'
export const PLAY_STORE_URLV2 = 'https://play.google.com/store/apps/details?id=com.pasarpolis.mitra&pcampaignid=web_share'
export const IOS_APP_STORE_URLV2 =  'https://apps.apple.com/in/app/pasarpolis-mitra/id1509962969'
